import React from 'react';
import { useTranslation } from './i18n.js';

function getInitialTheme() {
  if (typeof document === 'undefined') {
    return 'light';
  }
  const explicit = document.documentElement.getAttribute('data-theme');
  if (explicit === 'dark' || explicit === 'light') {
    return explicit;
  }
  return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function ThemeToggle() {
  const { t } = useTranslation();
  // Le serveur rend toujours 'light' (pas de `document` côté Node). Lire le vrai thème dès le
  // premier rendu client casserait l'hydratation dès que l'utilisateur a un thème sombre
  // enregistré (arbre différent de celui du serveur) : on garde 'light' comme état initial des
  // deux côtés, puis on corrige dans un effet, après l'hydratation.
  const [theme, setTheme] = React.useState('light');

  React.useEffect(() => {
    setTheme(getInitialTheme());
  }, []);

  const toggleTheme = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    document.documentElement.setAttribute('data-theme', next);
    window.localStorage.setItem('ui-theme', next);
    setTheme(next);
  };

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggleTheme}
      aria-label={theme === 'dark' ? t('themeToggleLight') : t('themeToggleDark')}
      title={theme === 'dark' ? t('themeToggleLight') : t('themeToggleDark')}
    >
      {theme === 'dark' ? '☀️' : '🌙'}
    </button>
  );
}
